import { FC, Fragment } from 'react';
import { Eye } from 'react-feather';
import ReactTooltip from 'react-tooltip';
import { Flex } from '.';
import { BaseType } from '../../utils/types';

type PropsType = {
  id: string;
  geographies: BaseType[] | undefined | null;
};

const GeographyCell: FC<PropsType> = props => {
  const { geographies, id } = props;
  if (geographies && geographies.length) {
    return geographies.length > 1 ? (
      <Fragment>
        <span data-tip={true} data-for={id}>
          <Eye />
        </span>
        <ReactTooltip id={id} effect="solid" place="bottom">
          <Flex direction="column" size="1" maxWidth="200px" justify="left">
            {geographies.map((g, i) => {
              return (
                <Fragment key={`${id}-${i}`}>
                  {g.name}
                  <br />
                </Fragment>
              );
            })}
          </Flex>
        </ReactTooltip>
      </Fragment>
    ) : (
      <Fragment>{geographies[0].name}</Fragment>
    );
  } else {
    return <Fragment />;
  }
};

export default GeographyCell;
